import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared';
import { FinancialItemDepreciationEventContainerModel } from '../../../../../../models/aggregates/erp/financial';

@Injectable({ providedIn: 'root' })
export class FinancialItemDepreciationEventService extends BaseApiTemplateService<FinancialItemDepreciationEventContainerModel> {

    static readonly ITEM_DEPRECIATION_EVENT_SUB_PATH = 'item-depreciation-events/';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + FinancialItemDepreciationEventService.ITEM_DEPRECIATION_EVENT_SUB_PATH + BaseApiTemplateService.BACKOFFICE_EP;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + FinancialItemDepreciationEventService.ITEM_DEPRECIATION_EVENT_SUB_PATH + BaseApiTemplateService.BACKOFFICE_EP;
        this.httpClient = http;
    }
}
